import { render } from "./popup-confirm.vue?vue&type=template&id=5e82fb3c&scoped=true"
import script from "./popup-confirm.vue?vue&type=script&lang=js"
export * from "./popup-confirm.vue?vue&type=script&lang=js"

import "./popup-confirm.vue?vue&type=style&index=0&id=5e82fb3c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e82fb3c"]])

export default __exports__